import {
	SET_RESTAURANTS,
} from '../actions/setRestaurants'

import merge from 'lodash/merge'

const initialState = {
	restaurants: []
}

export default function setRestaurantsReducers(state = initialState, action) {
	switch(action.type) {

		case SET_RESTAURANTS:
			return {
				...state,
				restaurants: merge({}, state.restaurants, action.payload)
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/setRestaurantsReducers.js